import React, {
    createContext,
    useContext,
    ReactNode,
    useMemo,
    useCallback,
    useState,
    useEffect,
} from 'react';
import PropTypes from 'prop-types';
import { RootState } from '../redux/store';
import { useDispatch, useSelector } from 'react-redux';
import { typesRedux } from '../shared/types/typesRedux';
import { asyncGetUserLog } from '../services/general.service';

interface Props {
    children?: ReactNode;
}

export const TOKEN = 'My_Token';

export const THEME = 'Mode_Theme';

const EXPIRATION_TOKEN = 'Expiration_Token';

export const AuthContext = createContext<any>(null);

export default function AuthContextProvider({ children }: Props) {
    const dispatch: any = useDispatch();
    const { token, exp, expirationToken } = useSelector(
        (state: RootState) => state.auth
    );
    const { mode, logUser } = useSelector((state: RootState) => state.general);
    const [tokenAuth, setTokenAuth] = useState<any>(
        localStorage.getItem(TOKEN)
    );
    const [dateExpirationToken, setDateExpirationToken] = useState<any | null>(
        localStorage.getItem(EXPIRATION_TOKEN)
    );
    const [modeTheme, setModeTheme] = useState<any>(
        localStorage.getItem(THEME)
    );

    const logout = useCallback(function () {
        setTokenAuth('');
        setDateExpirationToken('');
        localStorage.removeItem(TOKEN);
        localStorage.removeItem(EXPIRATION_TOKEN);
    }, []);

    useEffect(() => {
        if (token) {
            localStorage.setItem(TOKEN, token);
            setTokenAuth(token);
            localStorage.setItem(EXPIRATION_TOKEN, exp);
            setDateExpirationToken(exp);
        }
        if (mode) {
            localStorage.setItem(THEME, mode);
            setModeTheme(mode);
        }
        if (logUser === undefined && (token || tokenAuth)) {
            asyncGetUserLog().then((body: any) => {
                if (body.items !== undefined) {
                    dispatch({
                        type: typesRedux.USER_LOG,
                        payload: body.items[0],
                    });
                }
            });
        }
    }, [dispatch, token, tokenAuth, exp, mode, logUser]);

    useEffect(() => {
        if (dateExpirationToken !== null && dateExpirationToken !== '') {
            const timer = window.setInterval(() => {
                if (
                    expirationToken !== true &&
                    dateExpirationToken <= new Date()
                ) {
                    dispatch({ type: typesRedux.VALIDATION_TOKEN });
                }
            }, 6000);
            return () => {
                window.clearInterval(timer);
            };
        }
    }, [expirationToken, dateExpirationToken, dispatch]);

    const value = useMemo(
        () => ({
            tokenAuth,
            modeTheme,
            logout,
        }),
        [tokenAuth, modeTheme, logout]
    );

    return (
        <AuthContext.Provider value={value}>{children}</AuthContext.Provider>
    );
}

AuthContextProvider.propTypes = {
    children: PropTypes.object,
};

export function useAuthContext() {
    return useContext(AuthContext);
}
